
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("krs8y", function(module, exports) {

$parcel$export(module.exports, "NotificationsContentLoader", () => $d8b987b37f05e4bd$export$bae4076b81272f49);
$parcel$export(module.exports, "NotificationsComponent", () => $d8b987b37f05e4bd$export$277811c2f9b18413);

var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $4jR19 = parcelRequire("4jR19");

var $diswb = parcelRequire("diswb");

var $axAnW = parcelRequire("axAnW");

var $Asv1P = parcelRequire("Asv1P");

var $lGgRw = parcelRequire("lGgRw");

var $9Zu7R = parcelRequire("9Zu7R");
parcelRequire("c3uZU");
var $eOM9G = parcelRequire("eOM9G");

var $jUWCg = parcelRequire("jUWCg");

var $6cnUO = parcelRequire("6cnUO");
var $5izcQ = parcelRequire("5izcQ");
var $2Fndw = parcelRequire("2Fndw");

var $inPa6 = parcelRequire("inPa6");

var $lwNi3 = parcelRequire("lwNi3");

var $ljm2R = parcelRequire("ljm2R");

var $dEBDF = parcelRequire("dEBDF");

var $bQm3c = parcelRequire("bQm3c");

var $dPJCf = parcelRequire("dPJCf");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $3RJyD = parcelRequire("3RJyD");

var $8m7DH = parcelRequire("8m7DH");

var $djivE = parcelRequire("djivE");
const $d8b987b37f05e4bd$var$fabricNotificationLogUrl = '/gateway/api/notification-log';
const $d8b987b37f05e4bd$var$REFRESH_INTERVAL = 60000;
const $d8b987b37f05e4bd$var$CLEAR_BADGE_TIME = 10000;

const $d8b987b37f05e4bd$export$bae4076b81272f49 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZL8ot",
    name: "NotificationsContentLoader",
    loader: async ()=>(await (parcelRequire("9BGLZ"))).NotificationsContent
});
class $d8b987b37f05e4bd$var$EmptyNotificationLogClient extends (0, $eOM9G.default) {
    countUnseenNotifications() {
        return Promise.resolve({
            count: 0
        });
    }
    constructor(){
        super('', '');
    }
}
const $d8b987b37f05e4bd$export$277811c2f9b18413 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [showNotificationSpotlight, setShowNotificationSpotlight] = (0, $gwFzn.useState)(true);
    const [isCleared, setIsCleared] = (0, $gwFzn.useState)(false);
    const [unreadCount, setUnreadCount] = (0, $gwFzn.useState)('');
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { isSiteAdmin: isSiteAdmin, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $8m7DH.useRequestNotificationSpotlight)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const location = (0, $4y1GY.useLocation)();
    const { data: data, loading: loading } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $djivE.AppNavigationUnifiedQuery), {
        skip: !isLicensed
    });
    const shouldShowSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    (0, $gwFzn.useEffect)(()=>{
        if (isCleared) {
            const timeout = setTimeout(()=>{
                setIsCleared(false);
            }, $d8b987b37f05e4bd$var$CLEAR_BADGE_TIME);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        isCleared
    ]);
    const onClick = (0, $Asv1P.useCallbackWithAnalytics)(()=>{
        if (isOpen) {
            onClose();
            performance.clearMarks('notification.list.render.start');
        } else {
            performance.mark('notification.list.render.start');
            setIsCleared(true);
            setIsOpen(true);
        }
    }, {
        type: 'sendUIEvent',
        data: {
            source: 'globalNavigation',
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'notifications',
            attributes: {
                selectedItemPageContext: routeDataRef.current?.routeName,
                navigationLayer: 'global',
                navVersion: '3',
                navdexPointType: (0, $dEBDF.START_TOUCH)
            }
        }
    });
    const onMouseOverOnBell = ()=>{
        $d8b987b37f05e4bd$export$bae4076b81272f49.preload();
    };
    const focusNotificationBtn = ()=>{
        const notificationBtn = document.querySelector("[data-testid='app-navigation-notifications-button'] button");
        notificationBtn.focus();
    };
    const onClose = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(false);
        focusNotificationBtn();
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (isOpen && location && (0, $9wGTI.fg)('confluence-frontend-close-belldrawer-on-transition')) // on any transition close open notification drawer. On initial Load transitionId = 0
        onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onClose,
        location
    ]);
    const notificationLogClient = (0, $gwFzn.useMemo)(()=>new (0, $eOM9G.default)($d8b987b37f05e4bd$var$fabricNotificationLogUrl, undefined), []);
    const formatUnreadCount = (count)=>{
        if (count > 9) return ' (9+)';
        if (count > 0) return ` (${count})`;
        return '';
    };
    (0, $gwFzn.useEffect)(()=>{
        notificationLogClient.countUnseenNotifications().then((res)=>{
            setUnreadCount(formatUnreadCount(res.count));
            if (res.count >= 9) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'unseenNotificationsOver9'
                }
            }).fire();
        }).catch(()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireNotificationSpotlightCtaClickedEvent = (0, $gwFzn.useCallback)((buttonType)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'requestSpotlightButton',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'requestSpotlightButton',
                attributes: {
                    buttonType: buttonType
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const NotificationsBadge = (0, $gwFzn.useMemo)(()=>()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Zu7R.NotificationIndicator), {
                onCountUpdated: (count)=>{
                    setUnreadCount(formatUnreadCount(count.newCount));
                },
                notificationLogProvider: Promise.resolve(isCleared || isOpen ? new $d8b987b37f05e4bd$var$EmptyNotificationLogClient() : notificationLogClient),
                refreshRate: $d8b987b37f05e4bd$var$REFRESH_INTERVAL
            });
        }, [
        isOpen,
        isCleared,
        notificationLogClient
    ]);
    const renderNotificationsIcon = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jUWCg.Notifications), {
            badge: NotificationsBadge,
            onClick: onClick,
            onMouseEnter: onMouseOverOnBell,
            isSelected: isOpen,
            tooltip: isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                id: "app-navigation.notifications.link",
                defaultMessage: "Notifications{unreadCount}",
                values: {
                    unreadCount: unreadCount
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                shortcut: (0, $ljm2R.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
                contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                    id: "app-navigation.notifications.link",
                    defaultMessage: "Notifications{unreadCount}",
                    values: {
                        unreadCount: unreadCount
                    }
                })
            }),
            ...triggerProps
        });
    if (loading || !isLicensed) return null;
    else {
        const user = data?.user;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            "data-testid": "app-navigation-notifications",
            "data-vc": "app-navigation-notifications",
            ...ssrPlaceholderIdProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
            placement: "bottom-end",
            shouldFlip: true,
            rootBoundary: "viewport",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d8b987b37f05e4bd$export$bae4076b81272f49, {
                    user: user
                }),
            isOpen: isOpen,
            onClose: onClose,
            shouldRenderToParent: true,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                    "data-testid": "app-navigation-notifications-button"
                }, shouldShowSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                    name: "admin-request-spotlight"
                }, renderNotificationsIcon(triggerProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fndw.default), null, showNotificationSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $axAnW.default), {
                    client: coordinationClient,
                    messageId: (0, $3RJyD.SPOTLIGHT_MESSAGE_ID)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3RJyD.NotificationIconSpotlight), {
                    onClose: async ()=>{
                        setShowNotificationSpotlight(false);
                        fireNotificationSpotlightCtaClickedEvent('close');
                        await coordinationClient.stop((0, $3RJyD.SPOTLIGHT_MESSAGE_ID));
                    },
                    onViewRequests: async (e)=>{
                        e.stopPropagation();
                        setShowNotificationSpotlight(false);
                        setIsOpen(true);
                        fireNotificationSpotlightCtaClickedEvent('viewRequests');
                        await coordinationClient.stop((0, $3RJyD.SPOTLIGHT_MESSAGE_ID));
                    }
                })))) : renderNotificationsIcon(triggerProps))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
            deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.NOTIFICATIONS_SHORTCUT) : undefined,
            accelerator: (0, $ljm2R.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
            listener: onClick,
            isAppNavigationShortcut: true
        }));
    }
});

});
parcelRegister("axAnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9dab50b8978c7c$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
class $7e9dab50b8978c7c$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $gwFzn.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$7e9dab50b8978c7c$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};

});

parcelRegister("Asv1P", function(module, exports) {

$parcel$export(module.exports, "useCallbackWithAnalytics", () => $040545af9856ecf6$export$53c2b9c37c40e0d8);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $fTXBo = parcelRequire("fTXBo");
const $040545af9856ecf6$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const methodRef = (0, $fTXBo.useTrackedRef)(method);
    const payloadRef = (0, $fTXBo.useTrackedRef)(payload);
    return (0, $gwFzn.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("9Zu7R", function(module, exports) {

$parcel$export(module.exports, "NotificationIndicator", () => $d7b10312e31a364c$export$208fd20af21dc523);

var $cqKco = parcelRequire("cqKco");

var $1DWH0 = parcelRequire("1DWH0");
const $d7b10312e31a364c$export$208fd20af21dc523 = (0, $1DWH0.default)()((0, $cqKco.default));

});
parcelRegister("cqKco", function(module, exports) {

$parcel$export(module.exports, "default", () => $28ae02d12db6a953$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $c4sKh = parcelRequire("c4sKh");
const $28ae02d12db6a953$var$MAX_NOTIFICATIONS_COUNT = 9;
const $28ae02d12db6a953$var$NAVIGATION_CHANNEL = 'navigation';
class $28ae02d12db6a953$var$NotificationIndicator extends (0, $gwFzn.Component) {
    async componentDidMount() {
        this.notificationLogProvider = await this.props.notificationLogProvider;
        this.refresh('mount');
        this.updateInterval();
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.refreshRate !== this.props.refreshRate) this.updateInterval();
    }
    componentWillUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
        if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    updateInterval() {
        const { refreshRate: refreshRate } = this.props;
        if (this.intervalId) clearInterval(this.intervalId);
        if (refreshRate && refreshRate > 0) this.intervalId = window.setInterval(this.timerTick, refreshRate);
    }
    render() {
        const { count: count } = this.state;
        const { appearance: appearance, max: max } = this.props;
        return count ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            "data-test-selector": "NotificationIndicator",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
                testId: "notification-indicator-badge",
                max: max,
                appearance: appearance,
                children: count
            })
        }) : null;
    }
    constructor(...args){
        super(...args);
        this.intervalId = void 0;
        this.visibilityChangesSinceTimer = 0;
        this.notificationLogProvider = void 0;
        this.state = {
            count: null
        };
        this.onVisibilityChange = ()=>{
            if (this.props.refreshOnVisibilityChange && this.shouldRefresh()) {
                this.visibilityChangesSinceTimer++;
                this.refresh('visibility');
            }
        };
        this.shouldRefresh = ()=>{
            return typeof document !== 'undefined' && !document.hidden || this.props.refreshOnHidden;
        };
        this.timerTick = ()=>{
            this.visibilityChangesSinceTimer = 0;
            this.refresh('timer');
        };
        this.handleAnalytics = (countUpdateProperties)=>{
            const { newCount: newCount, oldCount: oldCount, source: source } = countUpdateProperties;
            // Only fire an 'activating' analytics event if the notification indicator is 'activating' for the first time
            // ie going from a number of 0 (the indicator is not visible)
            // to a number > 0 (the indicator becomes visible)
            if (this.props.createAnalyticsEvent && newCount > 0 && oldCount === 0) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'activated',
                    attributes: {
                        badgeCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($28ae02d12db6a953$var$NAVIGATION_CHANNEL);
            }
            if (this.props.createAnalyticsEvent && newCount !== oldCount) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'updated',
                    attributes: {
                        oldCount: oldCount,
                        newCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($28ae02d12db6a953$var$NAVIGATION_CHANNEL);
            }
        };
        this.refresh = async (source)=>{
            // Provider should be available by this point, if not, we exit.
            if (!this.notificationLogProvider) return;
            // If user is not viewing the webpage, then skip this refresh to avoid unnecessary request.
            if (!this.shouldRefresh()) return;
            const visibilityChangesSinceTimer = this.visibilityChangesSinceTimer;
            const updatingEvent = {
                source: source,
                visibilityChangesSinceTimer: visibilityChangesSinceTimer
            };
            const updatingResult = this.props.onCountUpdating && this.props.onCountUpdating(updatingEvent) || {};
            if (updatingResult.skip) return;
            try {
                const count = updatingResult.countOverride || (await this.notificationLogProvider.countUnseenNotifications({
                    queryParams: {
                        currentCount: this.state.count || 0
                    }
                })).count;
                if (this.state.count === null || this.state.count !== count) {
                    const countUpdateProperties = {
                        oldCount: this.state.count || 0,
                        newCount: count,
                        source: source
                    };
                    this.handleAnalytics(countUpdateProperties);
                    if (this.props.onCountUpdated) this.props.onCountUpdated(countUpdateProperties);
                    this.setState({
                        count: count
                    });
                }
            } catch (e) {
            // Do nothing
            }
        };
    }
}
$28ae02d12db6a953$var$NotificationIndicator.defaultProps = {
    appearance: 'important',
    max: $28ae02d12db6a953$var$MAX_NOTIFICATIONS_COUNT,
    refreshRate: 0,
    refreshOnHidden: false,
    refreshOnVisibilityChange: true
};
var $28ae02d12db6a953$export$2e2bcd8739ae039 = $28ae02d12db6a953$var$NotificationIndicator;

});
parcelRegister("c4sKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3633338e39044437$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5dK2X = parcelRequire("5dK2X");

var $exYql = parcelRequire("exYql");
const $3633338e39044437$var$boxStyles = {
    root: "_2rkopd34 _18zr12x7 _1e0c116y _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i",
    default: "_bfhkm7j4",
    important: "_bfhkybec",
    primary: "_bfhkb29m",
    primaryInverted: "_bfhkvuon",
    removed: "_bfhk1gly"
};
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $3633338e39044437$var$neutral300 = '#DDDEE1';
const $3633338e39044437$var$red300 = '#FD9891';
const $3633338e39044437$var$blue300 = '#8FB8F6';
const $3633338e39044437$var$neutral1000 = '#292A2E';
const $3633338e39044437$var$styles = {
    root: "_2rkogqwt _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i _syaz1fxt",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1e6v",
    removed: "_bfhk1gly _syaz1fxt"
};
const $3633338e39044437$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    // Use this flag for allowing negative values(numbers) in badge component when custom number field is used
    if ((0, $dh538.fg)('platform_ken_2029_negative_numbers_badge')) return typeof children === 'number' && typeof max === 'number' ? (0, $exYql.formatValueWithNegativeSupport)(children, max) : children;
    return typeof children === 'number' && max ? (0, $exYql.formatValue)(children, max) : children;
}; /**
    * __Badge__
    *
    * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
    *
    * - [Examples](https://atlassian.design/components/badge/examples)
    * - [Code](https://atlassian.design/components/badge/code)
    * - [Usage](https://atlassian.design/components/badge/usage)
    */ 
const $3633338e39044437$var$Badge = /*#__PURE__*/ (0, $gwFzn.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $35pXk.default)([
            $3633338e39044437$var$styles.root,
            $3633338e39044437$var$styles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            backgroundColor: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $35pXk.default)([
            $3633338e39044437$var$boxStyles.root,
            $3633338e39044437$var$boxStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $3633338e39044437$var$textColors[appearance],
            children: $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
$3633338e39044437$var$Badge.displayName = 'Badge';
var $3633338e39044437$export$2e2bcd8739ae039 = $3633338e39044437$var$Badge;
const $3633338e39044437$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("exYql", function(module, exports) {

$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $1687c74e524fbc98$export$4b844743568d5983);
$parcel$export(module.exports, "formatValue", () => $1687c74e524fbc98$export$7c4d25c0c3217d8c);
function $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $1687c74e524fbc98$export$4b844743568d5983(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $1687c74e524fbc98$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $1687c74e524fbc98$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValue(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});




parcelRegister("c3uZU", function(module, exports) {

$parcel$export(module.exports, "NotificationLogClient", () => (parcelRequire("eOM9G")).default);

var $eOM9G = parcelRequire("eOM9G");

});
parcelRegister("eOM9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd92637de1593c4$export$2e2bcd8739ae039);

var $dwp40 = parcelRequire("dwp40");
const $5fd92637de1593c4$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
class $5fd92637de1593c4$export$2e2bcd8739ae039 {
    async countUnseenNotifications(options = {}) {
        const mergedOptions = {
            path: '/api/3/notifications/count/unseen',
            ...options,
            queryParams: {
                ...this.cloudId && {
                    cloudId: this.cloudId
                },
                source: this.source,
                ...options.queryParams || {}
            },
            requestInit: {
                mode: 'cors',
                headers: {
                    'x-app-version': `${"0.0.0-use.local"}-${$5fd92637de1593c4$export$b055de0e665cb20c}`
                },
                ...options.requestInit || {}
            }
        };
        return (0, $dwp40.utils).requestService(this.serviceConfig, mergedOptions);
    }
    constructor(baseUrl, cloudId, source = $5fd92637de1593c4$export$b055de0e665cb20c){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.source = void 0;
        this.serviceConfig = {
            url: baseUrl
        };
        this.cloudId = cloudId;
        this.source = source;
    }
}

});


parcelRegister("jUWCg", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $db2b40f06156720d$export$36ba2f559d49a8f6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3bb5K = parcelRequire("3bb5K");

var $hslOl = parcelRequire("hslOl");

var $8MTIk = parcelRequire("8MTIk");
const $db2b40f06156720d$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $db2b40f06156720d$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hslOl.BadgeContainer), {
        id: $db2b40f06156720d$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
            "aria-describedby": $db2b40f06156720d$var$NOTIFICATIONS_BADGE_ID,
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bb5K))), {
                spacing: "spacious",
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("3bb5K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01602fb49c3451f8884e2ed4b4e67e9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $250b00bee59854d3$var$_react = $250b00bee59854d3$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $250b00bee59854d3$var$_notification = $250b00bee59854d3$var$_interopRequireDefault((parcelRequire("ckcSY")));

var $250b00bee59854d3$var$_notification2 = $250b00bee59854d3$var$_interopRequireDefault((parcelRequire("jOLOx")));
function $250b00bee59854d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $250b00bee59854d3$var$NotificationIcon = (props)=>/*#__PURE__*/ $250b00bee59854d3$var$_react.default.createElement($250b00bee59854d3$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $250b00bee59854d3$var$_notification2.default
    }, props));
$250b00bee59854d3$var$NotificationIcon.Name = 'NotificationIconMigration';
var $250b00bee59854d3$var$_default = module.exports.default = $250b00bee59854d3$var$NotificationIcon;

});

parcelRegister("hslOl", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $79e06360c2294100$export$f710265eb5a003da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $79e06360c2294100$var$badgeContainerStyles = (0, $3jLHL.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $79e06360c2294100$var$containerStyles = (0, $3jLHL.css)({
    position: 'relative'
});
const $79e06360c2294100$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $79e06360c2294100$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $79e06360c2294100$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $3jLHL.jsx)(Badge, null)));
};

});


parcelRegister("lwNi3", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $5efec5cf952678ca$export$ddc368dc94a41e62);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $04e9M = parcelRequire("04e9M");

var $jOtRZ = parcelRequire("jOtRZ");

var $lBR3p = parcelRequire("lBR3p");
const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $gwFzn.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};

});
parcelRegister("lBR3p", function(module, exports) {

$parcel$export(module.exports, "getCoordinationClient", () => $b379edbfb382bc54$export$a3f969ef7d35205d);

var $5loD0 = parcelRequire("5loD0");

var $fw9LG = parcelRequire("fw9LG");
const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};

});
parcelRegister("5loD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b61f610720049a6$export$2e2bcd8739ae039);

var $ll2sR = parcelRequire("ll2sR");

var $4nGsu = parcelRequire("4nGsu");
class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}

});



parcelRegister("3RJyD", function(module, exports) {

$parcel$export(module.exports, "SPOTLIGHT_MESSAGE_ID", () => $70e7891a258e3bf6$export$d2ea4f931a71a509);
$parcel$export(module.exports, "NotificationIconSpotlight", () => $70e7891a258e3bf6$export$e8547abadc10dd6e);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $js7oX = parcelRequire("js7oX");

var $5RBJ9 = parcelRequire("5RBJ9");

var $inPa6 = parcelRequire("inPa6");

var $lwNi3 = parcelRequire("lwNi3");

var $8m7DH = parcelRequire("8m7DH");
const $70e7891a258e3bf6$export$d2ea4f931a71a509 = 'confluence-admin-request-spotlight';
const $70e7891a258e3bf6$export$269cdaea24f37ea6 = /*#__PURE__*/ (0, $gwFzn.memo)(({ onClose: onClose, onViewRequests: onViewRequests, intl: intl })=>{
    const { markSpotlightAsShown: markSpotlightAsShown } = (0, $8m7DH.useRequestNotificationSpotlight)();
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const messages = (0, $2nPZH.defineMessages)({
        spotlightNotificationText: {
            id: "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
            defaultMessage: // eslint-disable-next-line no-restricted-syntax
            "When someone in your team requests a new product you'll get a notification here now."
        },
        spotlightCloseButtonText: {
            id: "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
            defaultMessage: "Close"
        },
        spotlightViewRequestsButtonText: {
            id: "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
            defaultMessage: "View requests"
        }
    });
    // When the spotlight is viewed, mark as shown in local storage and stop the EP message
    (0, $gwFzn.useEffect)(()=>{
        markSpotlightAsShown();
        coordinationClient.stop($70e7891a258e3bf6$export$d2ea4f931a71a509);
    }, [
        markSpotlightAsShown,
        coordinationClient
    ]);
    const fireScreenEvent = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                action: 'viewed',
                name: 'requestSpotlightInlineDialog'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    // Fire analytics event when spotlight is viewed
    (0, $gwFzn.useEffect)(()=>{
        fireScreenEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5RBJ9.default), {
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        actions: [
            {
                onClick: (e)=>onViewRequests(e),
                text: intl.formatMessage(messages.spotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: intl.formatMessage(messages.spotlightCloseButtonText),
                appearance: 'subtle'
            }
        ]
    }, intl.formatMessage(messages.spotlightNotificationText));
});
const $70e7891a258e3bf6$export$e8547abadc10dd6e = (0, $js7oX.default)($70e7891a258e3bf6$export$269cdaea24f37ea6);

});
parcelRegister("8m7DH", function(module, exports) {

$parcel$export(module.exports, "useRequestNotificationSpotlight", () => $e369e230c411dfc1$export$fc67e45e56a8c796);

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $d2LG0 = parcelRequire("d2LG0");

var $bQm3c = parcelRequire("bQm3c");

var $w033M = parcelRequire("w033M");

var $fqxIY = parcelRequire("fqxIY");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $e369e230c411dfc1$export$7f7daa8dea90d2b2 = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming, graphql-relay-compat/no-apollo-fragments -- Read https://go/connie-relay-migration-fyi
(0, $d2LG0.default)`query UserPrivilegeQuery{...UserPrivilegeFragment}${(0, $fqxIY.UserPrivilegeFragment)}`;
const $e369e230c411dfc1$export$fc67e45e56a8c796 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { data: privilegeData } = (0, $diswb.useQuery)($e369e230c411dfc1$export$7f7daa8dea90d2b2, {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        skip: Boolean(undefined) // This query isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    });
    const [isSiteAdmin, setIsSiteAdmin] = (0, $gwFzn.useState)(false);
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $gwFzn.useState)(true);
    const spotlightLocalStorageKey = `${(0, $1UApO.keys).NOTIFICATION_SPOTLIGHT_VIEWED}_${cloudId}_${userId}`;
    const markSpotlightAsShown = (0, $gwFzn.useCallback)(()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NOTIFICATION_SPOTLIGHT_VIEWED, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setIsSiteAdmin((0, $w033M.getIsSiteAdminFromQuery)(privilegeData));
    }, [
        privilegeData
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setHasSpotlightBeenShown((0, $e9zUf.confluenceLocalStorageInstance).getItemAsBoolean(spotlightLocalStorageKey));
    }, [
        spotlightLocalStorageKey
    ]);
    return {
        isSiteAdmin: isSiteAdmin,
        hasSpotlightBeenShown: hasSpotlightBeenShown,
        markSpotlightAsShown: markSpotlightAsShown
    };
};

});
parcelRegister("fqxIY", function(module, exports) {

$parcel$export(module.exports, "UserPrivilegeFragment", () => $a00a0c8e01d012e6$export$4df5ca96a1ee2ad1);

var $d2LG0 = parcelRequire("d2LG0");
const $a00a0c8e01d012e6$export$ffe9f102e9338c59 = (0, $d2LG0.default)`fragment IsProductAdminFragment on Query{user(current:true){id confluence{operations{operation targetType}}}}`;
const $a00a0c8e01d012e6$export$ef17929f7b367371 = (0, $d2LG0.default)`fragment IsSiteAdminFragment on Query{isSiteAdmin}`;
const $a00a0c8e01d012e6$export$a66b8a69476fb7cb = (0, $d2LG0.default)`fragment HasUserAccessAdminRoleFragment on Query{hasUserAccessAdminRole}`;
const $a00a0c8e01d012e6$export$4df5ca96a1ee2ad1 = (0, $d2LG0.default)`fragment UserPrivilegeFragment on Query{...IsProductAdminFragment ...IsSiteAdminFragment ...HasUserAccessAdminRoleFragment}${$a00a0c8e01d012e6$export$ffe9f102e9338c59}${$a00a0c8e01d012e6$export$ef17929f7b367371}${$a00a0c8e01d012e6$export$a66b8a69476fb7cb}`;

});



parcelRegister("9BGLZ", function(module, exports) {

let $6fe8bf953d155e3d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6fe8bf953d155e3d$var$load("lCT7Q"),
    $6fe8bf953d155e3d$var$load("9V3qu"),
    $6fe8bf953d155e3d$var$load("dGLrg"),
    $6fe8bf953d155e3d$var$load("h0Exi"),
    $6fe8bf953d155e3d$var$load("faolR"),
    $6fe8bf953d155e3d$var$load("4gZEH"),
    $6fe8bf953d155e3d$var$load("h4Nf7"),
    $6fe8bf953d155e3d$var$load("f96v0"),
    $6fe8bf953d155e3d$var$load("aYGIV"),
    $6fe8bf953d155e3d$var$load("2YtxS"),
    $6fe8bf953d155e3d$var$load("hUMW4"),
    $6fe8bf953d155e3d$var$load("7qp3S"),
    $6fe8bf953d155e3d$var$load("5tHTv"),
    $6fe8bf953d155e3d$var$load("4fCJZ"),
    $6fe8bf953d155e3d$var$load("aZinD"),
    $6fe8bf953d155e3d$var$load("g9CVe"),
    $6fe8bf953d155e3d$var$load("4aLlP"),
    $6fe8bf953d155e3d$var$load("KsAVd"),
    $6fe8bf953d155e3d$var$load("jRHtw")
]).then(()=>parcelRequire('9Lz1A'));

});



//# sourceMappingURL=NotificationsComponent.3c95641c.js.map
